import { FC } from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Spacer } from '@zazume/zzm-base';

import { PageDetailContent } from '#/components/pages/detail/PageDetailContent';
import { BlockSkeleton } from '#/components/skeleton/block/BlockSkeleton';

const HeaderRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s6};
  `
);

const TitleColumn = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.s3};
    flex: 1;
  `
);

const Rows = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing.s5};
  `
);

interface Props {
  rows?: number;
}

export const DetailPageSkeleton: FC<Props> = ({ rows = 4 }) => {
  return (
    <PageDetailContent variant="with-aside-content">
      <HeaderRow>
        <BlockSkeleton width={40} height={40} />
        <TitleColumn>
          <BlockSkeleton width={180} height={20} />
          <BlockSkeleton width={120} height={14} />
        </TitleColumn>
      </HeaderRow>
      <Spacer vertical="sm" />
      <Rows>
        {[...Array(rows).keys()].map(index => (
          <BlockSkeleton key={index} height={16} />
        ))}
      </Rows>
    </PageDetailContent>
  );
};
